import { type FiltersMap } from "../../utils/filterUtils";
import FilterButtons from "../itemsViewHeader/filterButtons/FilterButtons";
import SearchInput from "../searchInput/SearchInput";

import MultiStateDropdown, {
  type MultiStateDropdownOption,
} from "components/dropdowns/multiStateDropdown/MultiStateDropdown";
import { getAssetsMultiStateOption } from "features/Library/Flows/Designer/FlowComponentsPanel/contentView/PanelComponent/helpers/assetsOptions";
import "./componentsFilter.scss";

export interface Props {
  id: string;
  filterOptions?: MultiStateDropdownOption<string>[];
  onFilterChange?: (context: string) => void;
  onSearchChange?: (value: string) => void;
  defaultOption?: string;
  defaultSearchTerm?: string;
  onFilterButtonClick?: () => void;
  appliedFilters?: FiltersMap;
  onResetFilter?: () => void;
}

function ComponentsFilter(props: Props) {
  const {
    id,
    filterOptions,
    onFilterChange,
    onSearchChange,
    defaultOption,
    defaultSearchTerm,
    onFilterButtonClick,
    appliedFilters = {},
    onResetFilter,
  } = props;

  return (
    <div className="components-panel-filter">
      {filterOptions ? (
        <div className="filter-dropdown-container">
          <MultiStateDropdown
            className="components-filter-dropdown"
            options={filterOptions}
            onContextChange={onFilterChange}
            key={id}
            defaultOption={defaultOption ? getAssetsMultiStateOption(defaultOption) : filterOptions[0]}
          />
        </div>
      ) : null}
      <SearchInput
        placeholder="Search"
        id={id}
        className="components-search"
        expandable
        onChange={onSearchChange}
        defaultValue={defaultSearchTerm}
      />
      <FilterButtons
        fluid
        className="components-filter"
        onlyIcon
        appliedFilter={appliedFilters}
        onlyResetIcon
        onFilterPress={onFilterButtonClick}
        onResetFilter={onResetFilter}
      />
    </div>
  );
}

export default ComponentsFilter;
